import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- IMPORT
import { useCart } from '../context/CartContext'; // <-- IMPORT
import { ShoppingCart, ArrowUpRight, Info } from 'lucide-react';

const ProductHeader = ({ product }) => {
  // --- ALL HOOKS MUST BE DECLARED AT THE TOP ---
  const [mainImage, setMainImage] = useState('');
  const [activeColor, setActiveColor] = useState(null);
  const { addToCart, openCart } = useCart();
  const navigate = useNavigate();

  // --- USEEFFECT FOR SIDE EFFECTS ---
  // This effect safely updates state when the `product` prop arrives from the API call.
  useEffect(() => {
    if (product) {
      // --- FIX: Use snake_case keys from the API ---
      setMainImage(product.gallery_images && product.gallery_images.length > 0 ? product.gallery_images[0] : product.image || '');
      setActiveColor(product.colors && product.colors.length > 0 ? product.colors[0].name : null);
    }
  }, [product]);

  if (!product) {
    return <div className="product-header-container loading">Loading...</div>;
  }// This effect re-runs only when the product object changes

  // --- HELPER FUNCTIONS ---
  const handleAddToCart = () => {
    addToCart(product);
    openCart();
  };

  const handleBuyNow = () => {
    addToCart(product);
    navigate('/checkout');
  };

  // --- CONDITIONAL RETURN FOR LOADING STATE ---
  // This now happens AFTER all hooks have been declared.
  if (!product) {
    return <div className="product-header-container loading">Loading product details...</div>;
  }

  return (
    <div className="product-header-container">
      {/* Left Column remains the same */}
      <div className="product-info-left">
        {/* ... (all the code for the left column) ... */}
        <h1>{product.name ? product.name.toUpperCase() : 'Loading...'}</h1>
        <h4>{product.shortDescription ? product.shortDescription: 'Loading...'}</h4>
        
        <div className="details-section">
          <h3>Product Features:</h3>
           <ul>
            {/* --- FIX: Check for product.details --- */}
            {product.details && product.details.map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div>

        <div className="shipping-note">
          <Info size={18} />
          <p>{product.shippingNote}</p>
        </div>

        <div className="action-buttons">
          <div className="price-display">{product.price} Dh</div>
          <button className="cart-btn" aria-label="Add to cart" onClick={handleAddToCart}>
              <ShoppingCart size={24} />
          </button>
          <button className="buy-now-btn" onClick={handleBuyNow}>
            <span>Buy Now</span>
            <ArrowUpRight className="arrow-icon" size={20} />
          </button>
        
        </div>
      </div>

      {/* Right Column: Image Gallery (Updated Structure) */}
      <div className="product-gallery-right">
        
        {/* New wrapper for Main Image + Color Swatches */}
        <div className="image-swatch-wrapper">
          <div className="main-image-container">
            <img src={mainImage} alt="Main product view" />
          </div>
        </div>
        
        {/* Thumbnail gallery remains below the new wrapper */}
        {product.gallery_images && product.gallery_images.length > 0 && (
          <div className="thumbnail-gallery">
            {product.gallery_images.map((image, index) => (
              <div key={index} className={`thumbnail ${mainImage === image ? 'active' : ''}`} onClick={() => setMainImage(image)}>
                <img src={`http://localhost:5000${image}`} alt={`Product thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        )}
        
      </div>
    </div>
    
  );
};

export default ProductHeader;